var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Header',{staticClass:"hero is-black is-fullheight"}),_c('VideoCTA'),_c('Programs'),_c('SpecialPrograms'),_c('WhatsappCTA'),_c('Trainers'),_c('ProgramsHorizontal'),_c('News'),_c('JoinUs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }